import { useState } from 'react';
import { getApiUrl } from '@/lib/api-config';

const getInitialBackendUrl = (): string => {
  // First check for runtime-configured API URL (set via setApiUrl in AppContainer)
  // This is the primary source in deployed environments like preprod where the URL
  // is configured at runtime from product settings
  const configuredApiUrl = getApiUrl();
  if (configuredApiUrl) {
    return configuredApiUrl.replace(/\/$/, '');
  }

  // Then check for environment variable (used in deployed environments)
  const envApiUrl = import.meta.env.VITE_API_BASE_URL;
  if (envApiUrl) {
    return envApiUrl.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname.includes('.e2b.app')) {
      const match = hostname.match(/(\d+)-(.+)\.e2b\.app/);

      if (match) {
        const [, , instanceId] = match;
        const backendUrl = `https://5000-${instanceId}.e2b.app`;
        return backendUrl;
      }
    }
  }
  // Default to localhost only for local development
  return 'http://localhost:5000';
};

// Export as a function for use in services
export const getBackendUrl = (): string => {
  return getInitialBackendUrl();
};

// Export as a hook for use in React components
export const useGetBackendUrl = () => {
  const [backendUrl] = useState<string>(getInitialBackendUrl);
  return backendUrl;
};
